import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AlertTriangle, ArrowRight } from "lucide-react";

const LABELS = { booking: "Booking", agoda: "Agoda" };

export function MissingChannelsAlert({ dark }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/channel-checklist/missing").then(({ data }) => setData(data)).catch(() => {});
  }, []);
  if (!data || !data.missing.length) return null;
  return (
    <div className={`rounded-xl border p-4 ${dark ? "border-amber-500/30 bg-amber-500/5" : "border-amber-300 bg-amber-50"}`} data-testid="missing-channels-alert">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-2">
        <h3 className={`font-display font-semibold flex items-center gap-2 ${dark ? "text-amber-300" : "text-amber-800"}`}>
          <AlertTriangle className="h-4 w-4" /> Channel penting belum terisi ({data.missing.length} property)
        </h3>
        <Link to="/admin/channel-checklist" className="text-xs font-medium text-[#D96635] hover:underline inline-flex items-center gap-1" data-testid="missing-channels-link">
          Buka Check list <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
      <div className="flex flex-wrap gap-2">
        {data.missing.map((m) => (
          <span key={m.property_id} className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs ${dark ? "border-slate-700 bg-slate-900 text-slate-300" : "border-amber-200 bg-white text-slate-700"}`} data-testid={`missing-channel-${m.property_id}`}>
            <span className="font-medium">{m.property_name}</span>
            <span className={dark ? "text-rose-400" : "text-rose-600"}>kurang: {m.missing.map((k) => LABELS[k] || k).join(", ")}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
